import type { SessionService } from '@efdigital/ll-addon-auth';
import { getOwner } from '@ember/owner';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import { initializeAuthHandler } from '../data/handlers/auth-handler.ts';
import type CoachService from '../services/coach.ts';

export default class ApplicationRoute extends Route {
  @service declare session: SessionService;
  @service declare coach: CoachService;
  @service declare router: RouterService;

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    // Auth: initialize the auth handler
    initializeAuthHandler(getOwner(this)!);
    await this.session.getCurrent();

    // Cronofy: try to validate the code from the query string
    const redeemResult = await this.coach.validateCodeFromQueryParams();
    if (redeemResult === 'none') {
      return;
    }

    // Coaches return here after Cronofy OAuth; send them to availability with
    // an optional error signal when linking failed.
    const queryParams =
      redeemResult === 'already_linked'
        ? { calendarSyncError: 'already_linked' }
        : redeemResult === 'failed'
          ? { calendarSyncError: 'failed' }
          : { calendarSyncError: null };

    this.router.transitionTo('coaching.coach.settings.availability', {
      queryParams,
    });
  }
}
